
// redux (action-types)
import {CLEAR_EXAM} from 'redux/reducers/exam/action-types'


const clearExam = () => ({type: CLEAR_EXAM});


export {clearExam}